import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'Types/utilTypes'
import { ReceivingFileModel } from 'Models'
import { FieldNames } from 'Constants/FieldNames'
import { FileContainer } from 'Modules'

export type FileState = {
	files: Map<string, ReceivingFileModel>
	fileBlobs: Map<string, ReceivingFileModel | Blob>
	requestedFiles: Set<string>
	fileContainersMap: Map<FieldNames, FileContainer[]>
}

export const fileInitialState: FileState = {
	files: new Map(),
	fileBlobs: new Map(),
	requestedFiles: new Set(),
	fileContainersMap: new Map(),
}

export namespace FileNS {
	export type GetFile = PayloadAction<{
		url: string
		callback?: Callback
		errorCallback?: Callback
	}>
	export type SetFile = PayloadAction<{
		url: string
		file: ReceivingFileModel
	}>
	export type GetFileBlob = PayloadAction<{
		url: string
		hideDefaultLoader?: boolean
		callback?: Callback
		errorCallback?: Callback
	}>
	export type SetFileBlob = PayloadAction<{
		url: string
		file: ReceivingFileModel | Blob
	}>
	export type SetRequestedFile = PayloadAction<string>
	export type RemoveRequestedFile = PayloadAction<string>
	export type DownloadSecureFile = PayloadAction<{
		file: string
		filename: string
	}>
	export type ClearAll = PayloadAction
	export type SetFileContainer = PayloadAction<{
		fieldName: FieldNames
		fileContainersList: FileContainer[]
	}>
}

export const fileSlice = createSlice({
	name: 'files',
	initialState: fileInitialState,
	reducers: {
		getFile: (state, action: FileNS.GetFile) => {},
		setFile: (state, action: FileNS.SetFile) => {
			const { url, file } = action.payload
			state.files.set(url, file)
		},
		getFileBlob: (state, action: FileNS.GetFileBlob) => {},
		setFileBlob: (state, action: FileNS.SetFileBlob) => {
			const { url, file } = action.payload
			state.fileBlobs.set(url, file)
		},
		setRequestedFile: (state, action: FileNS.SetRequestedFile) => {
			state.requestedFiles.add(action.payload)
		},
		removeRequestedFile: (state, action: FileNS.RemoveRequestedFile) => {
			state.requestedFiles.delete(action.payload)
		},
		downloadSecureFile: (state, action: FileNS.DownloadSecureFile) => {},
		clearAll: (state, action: FileNS.ClearAll) => {
			return fileInitialState
		},
		setFileContainersList: (state, action: FileNS.SetFileContainer) => {
			state.fileContainersMap.set(action.payload.fieldName, action.payload.fileContainersList)
		},
		clearFileContainerList: (state, action: FileNS.SetFileContainer) => {
			state.fileContainersMap.set(action.payload.fieldName, [])
		},
	},
})
